<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>
            <slot name="new_btn">
              <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">新增</Button>
            </slot>
            <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border
                 :columns="columns" :data="tableData"
                 @on-selection-change="handleSelectChange"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <FormItem
                                            label="协作单位"
                                            prop="company"
                                        >
                                            <el-select
                                              :disabled="formValidate.id !== 0"
                                                v-model="formValidate.company"
                                                filterable
                                                remote
                                                reserve-keyword
                                                placeholder="请输入协作单位"
                                                :remote-method="remoteMethod"
                                                :loading="loading">
                                                <el-option
                                                    v-for="item in companyoptions"
                                                    :key="item.Cname"
                                                    :label="item.Cname"
                                                    :value="item.Cname">
                                                </el-option>
                                            </el-select>
                                        </FormItem>
              <FormItem
                label="合同编号"
                prop="contractid"
              >
                <Input
                  v-model="formValidate.contractid"
                  placeholder="请输入合同编号"
                ></Input>
              </FormItem>
              <FormItem
                label="合同名称"
                prop="title"
              >
                <Input
                  v-model="formValidate.title"
                  placeholder="请输入合同名称"
                ></Input>
              </FormItem>
              <FormItem
                label="开始时间"
                prop="stime"
              >
                <DatePicker type="date" editable v-model="formValidate.stime" format="yyyy-MM-dd"
                            placement="bottom-end" placeholder="请选择开始时间"></DatePicker>
              </FormItem>
              <FormItem
                label="结束时间"
                prop="etime"
              >
                <DatePicker type="date" editable v-model="formValidate.etime" format="yyyy-MM-dd"
                            placement="bottom-end" placeholder="请选择结束时间"></DatePicker>
              </FormItem>
              <FormItem
                label="内容"
                prop="content"
              >
                <Input
                  v-model="formValidate.content"
                  placeholder="请输入内容"
                ></Input>
              </FormItem>
              <FormItem
                label="状态"
                prop="status"
              >
                <el-select
                  v-model="formValidate.status"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择状态">
                  <el-option
                    v-for="item in statusList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="parseInt(item.value)">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="备注"
                prop="remark"
              >
                <Input
                  v-model="formValidate.remark"
                  placeholder="请输入备注"
                ></Input>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>
            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>

import {
  getLaborcontractlist,
  operationLaborcontract
} from '@/api/labor/laborcontract.js'
import {getsysparameterList} from '@/api/system/sys_parameter'
import {
  getCompanylist
} from '@/api/scinfo/scinfo.js'

let moment = require('moment')
export default {
  data () {
    return {
      companyoptions: [],
      statusList: [],
      loading: false,
      spinShow: false,
      fullscreenLoading: false,
      formValidate: {},
      searchVal: '',
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: '新建'
      },
      tableSelectIdList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数

      ruleValidate: {
        contractid: [
          {
            required: true,
            message: '合同编号不能为空',
            trigger: 'blur'
          }
        ],
        title: [
          {
            required: true,
            message: '合同名称不能为空',
            trigger: 'blur'
          }
        ],
        stime: [
          {
            required: true,
            type: 'date',
            message: '请选择开始时间',
            trigger: 'change'
          }
        ],
        etime: [
          {
            required: true,
            type: 'date',
            message: '请选择结束时间',
            trigger: 'change'
          }
        ],
        content: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'blur'
          }
        ]
      },
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
                          title: '协作单位',
                          key: 'company',
          tooltip: true,
                          width: 200,
                          align: 'center',
                          sortable: true },
        {
          title: '合同编号',
          key: 'contractid',
          tooltip: true,
          width: 150,
          align: 'center',
          sortable: true },
        {
          title: '合同名称',
          key: 'title',
          tooltip: true,
          width: 150,
          align: 'center',
          sortable: true },
        {
          title: '开始时间',
          key: 'stime',
          tooltip: true,
          width: 150,
          align: 'center',
          sortable: true },
        {
          title: '结束时间',
          key: 'etime',
          tooltip: true,
          width: 150,
          align: 'center',
          sortable: true },
        {
          title: '内容',
          key: 'content',
          tooltip: true,
          align: 'center',
          sortable: true },
        {
          title: '电子合同',
          key: 'filepath',
          tooltip: true,
          width: 150,
          align: 'center',
          sortable: true },
        {
          title: '状态',
          key: 'status_CN',
          tooltip: true,
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '备注',
          tooltip: true,
          key: 'remark',
          width: 200,
          align: 'center',
          sortable: true },
        {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 180,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editModal(params.row, 'post', '修改')
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.delData(params)
                    }
                  }
                },
                '删除'
              )
            ])
          }
        }
      ]
    }
  },
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          getCompanylist(1, 20, query, '').then(res => {
            if (res.data.code === 0) {
              this.companyoptions = res.data.data
            }
          })
        }, 200)
      } else {
        this.companyoptions = []
      }
    },
    getLaborcontractlist (key, value) {
      this.spinShow = true
      getLaborcontractlist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          this.tableData = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    getParameterList () {
      getsysparameterList('labor_contract', 'status').then(res => {
        if (res.data.code === 0) {
          this.statusList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
    },
    handleSelectChange (val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.id)
      })
      this.tableSelectIdList = SelectIdList
    },
    closeModal () {
      this.dialog.show = false
    },
    editModal (paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true
      this.modalMap.modalTitle = mtitle
      this.editModalData = meth
      this.getParameterList()
      var day2 = new Date()
      day2.setTime(day2.getTime())
      var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
      if (paramsRow && paramsRow.id) {
        this.formValidate = {
          id: paramsRow.id,
          contractid: paramsRow.contractid,
          title: paramsRow.title,
          stime: paramsRow.stime,
          etime: paramsRow.etime,
          content: paramsRow.content,
          filepath: paramsRow.filepath,
          status: paramsRow.status,
          remark: paramsRow.remark
        }
      } else {
        this.formValidate = {
          id: 0,
          contractid: '',
          title: '',
          stime: s2,
          etime: s2,
          content: '',
          filepath: '',
          status: 1,
          remark: ''
        }
      }
    },
    handleSubmit (value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.formValidate.stime = moment(this.formValidate.stime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            this.formValidate.etime = moment(this.formValidate.etime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            operationLaborcontract(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getLaborcontractlist(this.searchVal)
                } else {
                  this.getLaborcontractlist()
                }
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
        } else {
          this.$Message.error('缺少必要参数')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    handlerDelete () {
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中数据嘛？ `)) {
          operationLaborcontract({'id_list': this.tableSelectIdList}, 'delete').then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getLaborcontractlist(this.searchVal)
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    delData (params) {
      if (confirm(`确定要删除该信息吗？`)) {
        operationLaborcontract(
          {
            'id': params.row.id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    changePage (value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getLaborcontractlist(this.searchVal)
      } else {
        this.getLaborcontractlist()
      }
    },
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getLaborcontractlist(this.searchVal)
      } else {
        this.getLaborcontractlist()
      }
    },
    searchinput () {
      if (this.searchVal) {
        this.getLaborcontractlist(this.searchVal)
      } else {
        this.getLaborcontractlist()
      }
    }
  },
  watch: {
    searchVal (val) {
      this.searchVal = val
    }
  },
  mounted () {
    this.getLaborcontractlist()
  }
}
</script>
<style lang="less" scoped>
.search-con {
  padding: 10px 0;
  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }
    &-input {
      display: inline-block;
     width: 200px;
      margin-left: 2px;
    }
    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
